import { reducer as toastrReducer } from 'react-redux-toastr';

import { combineReducers } from 'redux';

import activities from './activities/reducer';
import cep from './cep/reducer';
import comments from './comments/reducer';
import dataList from './dataList/reducer';
import dynamicTable from './dynamicTable/reducer';
import importProcesses from './importProcesses/reducer';
import modal from './modal/reducer';
import processes from './processes/reducer';
import reports from './reports/reducer';
import tasks from './tasks/reducer';
import users from './users/reducer';

export default combineReducers({
  toastr: toastrReducer,
  activities,
  cep,
  comments,
  dataList,
  dynamicTable,
  importProcesses,
  modal,
  processes,
  reports,
  tasks,
  users,
});
